import { useNavigate } from 'react-router-dom';
import HomeScreenButton from '../atoms/HomeScreenButton';
import { HomeScreenButtonConfig, HomeScreenButtonProps } from '../atoms/HomeScreenButton.types';

const FavoritesHomeScreenButton = ({ customLabel, customIcon }: HomeScreenButtonConfig) => {
    const navigate = useNavigate();

    const buttonProps: HomeScreenButtonProps = {
        label: customLabel || 'Favoritenspeicher',
        iconPath: 'icon_star_homescreen.svg',
        customIconSvg: customIcon
    };

    return (
        <HomeScreenButton
            buttonProps={buttonProps}
            action={() => navigate('favorites')}
            isHidden={false}
            disabled={false}
        />
    );
};
export default FavoritesHomeScreenButton;